// extracted by mini-css-extract-plugin
export default {"bootstrapSpinner":"styles_bootstrapSpinner__Ww1eG"};